module.exports = __webpack_public_path__ + "static/media/radio_brand.250105f6.svg";